import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import EditorialFrame, { type EditorialInjectedProps, type EditorialLayoutProps } from './EditorialFrame';

const EditorialCoverContent: React.FC<EditorialInjectedProps & { content: any }> = ({ content, tokens, isStory }) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const highlights = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      {content.kicker ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: isStory ? 28 : 20,
            color: t.accent,
            fontSize: typeSize(isStory ? 11 : 9.5),
            fontWeight: 800,
            letterSpacing: 2.4,
            textTransform: 'uppercase'
          }}
        >
          <span style={{ width: isStory ? 32 : 25, height: 2, background: t.accent }} />
          <span>{content.kicker}</span>
        </div>
      ) : null}

      <h1
        style={{
          maxWidth: 288,
          margin: 0,
          color: t.ink,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 48 : 37),
          fontWeight: 700,
          letterSpacing: '-1.7px',
          lineHeight: 1.04
        }}
      >
        {content.title}
      </h1>

      {content.subtitle ? (
        <div
          style={{
            maxWidth: 274,
            marginTop: isStory ? 26 : 19,
            color: t.muted,
            fontFamily: t.serif,
            fontSize: typeSize(isStory ? 16 : 13.5),
            fontStyle: 'italic',
            lineHeight: 1.55
          }}
        >
          {content.subtitle}
        </div>
      ) : null}

      {highlights.length ? (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px 15px',
            maxWidth: 285,
            marginTop: isStory ? 30 : 22
          }}
        >
          {highlights.map((highlight: string, index: number) => (
            <span
              key={`${index}-${highlight}`}
              style={{
                paddingBottom: 3,
                borderBottom: `1px solid ${t.line}`,
                color: t.accent,
                fontSize: typeSize(isStory ? 11.5 : 10),
                fontWeight: 700,
                letterSpacing: 0.4
              }}
            >
              {highlight}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const EditorialCoverLayout: React.FC<EditorialLayoutProps> = props => (
  <EditorialFrame {...props}>
    <EditorialCoverContent content={props.content || {}} />
  </EditorialFrame>
);

export default EditorialCoverLayout;
